// Status translation function
export const translateStatus = (status) => {
  const translations = {
    'PENDING': 'Oczekujący',
    'SENT': 'Wysłany',
    'FAILED': 'Niepowodzenie',
    'REPLIED': 'Odpowiedziano',
    'CANCELLED': 'Anulowano',
    'IMPORTED': 'Zaimportowano',
    'CREATED': 'Utworzono',
    'GENERATED': 'Wygenerowano',
    'COMPLETED': 'Zakończono',
    'CONFIRMED_READY': 'Potwierdzono gotowość',
    'SCHEDULED_PICKUP': 'Zaplanowano odbiór'
  };
  return translations[status] || status;
};

